import { render, staticRenderFns } from "./ClassifcationUpload.vue?vue&type=template&id=3712d75c&"
import script from "./ClassifcationUpload.vue?vue&type=script&lang=ts&"
export * from "./ClassifcationUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports